import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Projects() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Projects</span>
                    </div>
                </section>

                <section class="web3bank simple projects">
                    <div data-lavalamp=""></div>
                    <div class="content no-before ">
                        <div class="pad texts">
                            <div class="left">
                                <h1>Our Projects<br /><b>The NuGenesis Flagship</b></h1>
                                <div class="subtitle">
                                    NuCoin
                                </div>
                                <div class="text">
                                    NuCoin is the native currency in the NuGenesis ecosystem. <br /><br />
                                    NuGenesis' flagship blockchain, NuCoin, is fully operational and is already at zero-carbon emissions. It is way past the Proof Of Work (POW) vs Proof Of Stake (POS) debate! <br /><br />
                                    With Proof of Authority with useful work AI (Artificial Intelligence) as one of several consensus mechanisms, including consensus before packing, NuGenesis’ NuCoin uses system validator nodes running on the randomness of a round robin protocol and monitored by AI to underscore system integrity. <br /><br />
                                    The streamlined validation process, through the super nodes with byzantine fault tolerance and randomness, reduces unnecessarily superfluous broadcasting through validation networks. Being gasless, there are no requests from 1000’s of validators and fee actions.

                                </div>
                                <div class="btns">
                                </div>
                            </div>
                            <div class="right">
                                <div class="img-frame not-top">
                                    <video src="media/NuGenesis - NuCoin.mp4"  autoplay="autoplay" loop="loop" muted="muted" playsinline=""></video>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
            <Footer />
        </>
    )
}